import TimerList from "../../constants/TimerList";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import moment from "moment";

export const dateFunction = (date: string): string => {

    const dateObject = moment(date).toDate();
    let day = new Date(dateObject).getDate().toString()
    let month = (new Date(dateObject).getMonth() + 1).toString()
    const year = new Date(dateObject).getFullYear();
    month = month.length === 1 ? '0' + month : month;
    day = day.length === 1 ? '0' + day : day;
    return `${day}/${month}/${year}`;
}

export const dateFunctionUS = (date: string): string => {

    const dateObject = moment(date).toDate();
    let day = new Date(dateObject).getDate().toString()
    let month = (new Date(dateObject).getMonth() + 1).toString()
    const year = new Date(dateObject).getFullYear();
    month = month.length === 1 ? '0' + month : month;
    day = day.length === 1 ? '0' + day : day;
    return `${month}/${day}/${year}`;
}


export const formatBartenderDate = (date: string): string => {
    const dateArray = date.split('-');
    return `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
}

// start and endtime difference
export function getTimeDifference(startTime: string, endTime: string): { hours: number; minutes: number } {
    // Parse the times as Date objects
    const start: Date = new Date(`1970-01-01T${startTime}:00`);
    const end: Date = new Date(`1970-01-01T${endTime}:00`);
  
    // Calculate the difference in milliseconds
    const diffInMs: number = end.getTime() - start.getTime();
  
    // Convert the difference to hours and minutes
    const diffInHours: number = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes: number = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  
    return { hours: diffInHours, minutes: diffInMinutes };
  }


  // db date to am pm retun  e.g. 12:00 AM
  export const timeToAmPm = (time: string, timezone: string) => {
    return TimerList.find(
      (t) => t.value === format(toZonedTime(time, timezone), "HH:mm").toString()
    )?.label;
  };

  // convert stripe time

  export const  convertStripeTime = (time:number)=>{
    return new Date(time * 1000)
  }